// import axios from "axios";
import apiManagement from "../config/api_management";
import getHeaders from "./getHeaders";

// const apiManagement = axios.create({
//   baseURL: "http://localhost:8081",
// });

export function findAll(payload) {
  const {
    groupId,
    farmId,
    page = 0,
    size = 10,
    sort = "id",
    direction = "ASC",
    search,
  } = payload;
  const params = new URLSearchParams({ page, size, sort, direction });
  if (search) params.append("search", search);
  return apiManagement.get(
    `/bovexo/${groupId}/farms/${farmId}/group-items?${params.toString()}`,
    getHeaders(false, null),
  );
}

export function save(payload) {
  const { groupId, farmId, id, body } = payload;
  if (id == null) {
    return apiManagement.post(
      `/bovexo/${groupId}/farms/${farmId}/group-items`,
      body,
      getHeaders(false, null),
    );
  }
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/${farmId}/group-items/${id}`,
    body,
    getHeaders(false, null),
  );
}

export function saveForGroup(payload) {
  const { groupId, id, body } = payload;
  if (id == null) {
    return apiManagement.post(
      `/bovexo/${groupId}/farms/group-items`,
      body,
      getHeaders(false, null),
    );
  }
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/group-items/${id}`,
    body,
    getHeaders(false, null),
  );
}

export function inactivate(payload) {
  const { groupId, farmId, id } = payload;
  return apiManagement.delete(
    `/bovexo/${groupId}/farms/${farmId}/group-items/${id}`,
    getHeaders(false, null),
  );
}

export function activate(payload) {
  const { groupId, farmId, id } = payload;
  return apiManagement.patch(
    `/bovexo/${groupId}/farms/${farmId}/group-items/${id}/active`,
    null,
    getHeaders(false, null),
  );
}
